module.exports = __webpack_public_path__ + "71406aeb84239c668be44f60fded0639.pdf";